function decodeHtmlEntities(text: string): string {
  const entities: Record<string, string> = {
    "&nbsp;": " ",
    "&rdquo;": '"',
    "&ldquo;": '"',
    "&rsquo;": "'",
    "&lsquo;": "'",
    "&amp;": "&",
    "&lt;": "<",
    "&gt;": ">",
    "&quot;": '"',
    "&#39;": "'",
  };

  let decoded = text;
  Object.keys(entities).forEach((entity) => {
    decoded = decoded.replace(new RegExp(entity, "g"), entities[entity]);
  });

  decoded = decoded.replace(/&#(\d+);/g, (match, dec) =>
    String.fromCharCode(dec)
  );

  return decoded;
}

export function parseModelWearsContent(sizeAndFit?: unknown): string | null {
  if (!sizeAndFit || typeof sizeAndFit !== "string") {
    return null;
  }

  const sizeFitContent = decodeHtmlEntities(sizeAndFit)
    .replace(/\s+/g, " ")
    .trim();
  const sizeFitContentLower = sizeFitContent.toLowerCase();

  const modelMatches = sizeFitContent.match(/model/gi) || [];
  if (
    modelMatches.length >= 4 ||
    modelMatches.length === 0 ||
    sizeFitContentLower.includes("second model") ||
    sizeFitContentLower.includes("bump") ||
    sizeFitContentLower.includes("pregnant") ||
    sizeFitContentLower.includes("tbc")
  ) {
    return null;
  }

  const heightMatch = sizeFitContent.match(
    /(?:model(?:'s)?\s+)?height(?:'s)?:\s*(.*?)(?=\s*(?:<|\||model|is wearing|wearing|wears|$))/i
  );

  const wearingMatch = sizeFitContent.match(
    /(?:model\s+)?(?:wears|is wearing|wearing):?\s*(.*?)(?=\s*(?:<|\||model(?:'s)?\s+height|$))/i
  );

  if (heightMatch || wearingMatch) {
    const heightInfo = heightMatch ? heightMatch[1].trim() : "";
    const wearingInfo = wearingMatch ? wearingMatch[1].trim() : "";

    if (!heightInfo && !wearingInfo) {
      return null;
    }

    const separator = '<span aria-hidden="true">|</span>';
    let finalText = "Model:";
    const hasHeight = Boolean(heightInfo);

    if (hasHeight) {
      finalText += ` ${heightInfo}`;
    }

    if (wearingInfo) {
      finalText += hasHeight
        ? ` ${separator} Wearing ${wearingInfo}`
        : ` Wearing ${wearingInfo}`;
    }

    const textWithoutAriaSpan = finalText.replace(separator, "");
    if (textWithoutAriaSpan.trim().length >= 100) {
      return null;
    }

    return finalText;
  }

  return null;
}
